type Features = readonly string[] | null | undefined;
/**
 * Determines if a user is targeted for benefits-focused features.
 */
export function isBenefitsTargeted(features: Features): boolean {
  return (
    features?.includes("MAXIMIZE_BENEFITS") === true &&
    !isBillCheckingTargeted(features)
  );
}
/**
 * Determines if a user is targeted for fix billing errors.
 */
export function isBillCheckingTargeted(features: Features): boolean {
  return features?.includes("FIX_BILLING_ERRORS") ?? false;
}
